import { sleep } from "./others";

/* ------------------------------------------------------------------
 *  汎用的なフォームに関する関数
--------------------------------------------------------------------- */
function word_count() {
  // TODO: 画像の変更にも気づけるように
  let count = 0;
  for (var i = 0; i < $("input[type='text']").length; i += 1) {
    count += $("input[type='text']").eq(i).val().length;
  }
  for (var i = 0; i < $("input[type='checkbox']:checked").length; i += 1) {
    count += $("input[type='checkbox']:checked").eq(i).val().length;
  }
  for (var i = 0; i < $("textarea").length; i += 1) {
    count += $("textarea").eq(i).val().length;
  }
  return count;
}

/* ------------------------------------------------------------------
hide後、その中にあるrequiredを削除する
--------------------------------------------------------------------- */
$.fn.hide_and_require_false = function () {
  this.hide(0, function () {
    $(this)
      .find(".jsRequired")
      .each((i, input) => {
        $(input).attr("required", false);
      });
  });
};
/* ------------------------------------------------------------------
show後、その中にあるrequiredを復活する
--------------------------------------------------------------------- */
$.fn.show_and_require_true = function () {
  this.show(0, function () {
    $(this)
      .find(".jsRequired")
      .each((i, input) => {
        $(input).attr("required", true);
      });
  });
};

/* ------------------------------------------------------------------
フォームに何か入力した場合ページ離脱前に警告
--------------------------------------------------------------------- */
function showAlertBeforeLeaves() {
  $(document).ready(() => {
    initial_count = word_count(); // 初期状態の文字数保存
    modified = false;
    $(window).unbind();

    // 変更時，初期状態の文字数と比較
    $(document).on("keyup change", () => {
      // limitが1のcheckboxの変更は察知できない..
      if (initial_count != word_count()) {
        modified = true;
      }
    });

    $(".p_btn").click(() => {
      modified = false;
      initial_count = word_count();
    });

    // NOTE: 送信ボタンが .p_btn 以外のページ（名古屋ポータル等）でも送信時に離脱警告を出さない
    // NOTE: 応募フォームに限定しないと、ログインフォーム等の送信でも警告が消え入力が失われる
    // NOTE: preventDefaultで送信キャンセルされた場合は入力が残るため警告を維持する
    $(document).on("submit", "#jsNewContact", (e) => {
      if (!e.isDefaultPrevented()) {
        modified = false;
      }
    });

    // ページ離脱時の警告
    $(window).on("beforeunload", () => {
      if (modified) {
        return "保存が完了していません。";
      }
    });
    $(window).on("page:before-change", () => {
      if (modified) {
        return confirm("保存が完了していません。このページから移動しますか？");
      }
    });
  });
}

/* ------------------------------------------------------------------
 *  バリデーションに関する処理
--------------------------------------------------------------------- */
// 汎用的なバリデーションメソッド
const checkFieldValidation = (field) => {
  const element = field instanceof jQuery ? field[0] : field;
  if ($(element).hasClass("jsBirthdaySelect"))
    return checkBirthdayValidation($(element)); // 誕生日選択のみ特殊処理
  return element.validity.valid;
};

const validationErrorMessage = (input, errorMessages = {}) => {
  const element = input instanceof jQuery ? input[0] : input;
  const { validity } = element;

  if (validity.valueMissing)
    return errorMessages.required
      ? errorMessages.required
      : element.validationMessage;
  if (validity.patternMismatch)
    return errorMessages.pattern
      ? errorMessages.pattern
      : element.validationMessage;
  if (validity.tooLong)
    return errorMessages.maxlength
      ? errorMessages.maxlength
      : element.validationMessage;
  if (validity.tooShort)
    return errorMessages.minlength
      ? errorMessages.minlength
      : element.validationMessage;
  if (validity.typeMismatch)
    return errorMessages.type ? errorMessages.type : element.validationMessage;
  if (validity.badInput)
    return errorMessages.badInput
      ? errorMessages.badInput
      : element.validationMessage;

  return element.validationMessage;
};

const isValueMissing = (field) => {
  const element = field instanceof jQuery ? field[0] : field;
  return element.validity.valueMissing;
};

const checkBirthdayValidation = (select) => {
  const element = select instanceof jQuery ? select[0] : select;
  const birthdaySelects = $(element.form).find("select.jsBirthdaySelect");
  return isAllSelected(birthdaySelects);
};

const isAllSelected = (selects) => {
  let isSelected = true;
  selects.each((index, element) => {
    if (isValueMissing($(element))) {
      isSelected = false;
      return false;
    }
  });
  return isSelected;
};

// ===========================================================================
// リアルタイムバリデーション
const realTimeValidation = (formSelector) => {
  const initializeValidate = (formSelector) => {
    $(formSelector)
      .find("input, textarea, select")
      .each((index, element) => {
        putCheckMark($(element));
        changeDesignWhetherToPassedValidation($(element));
      });
  };

  const validateChangedFields = (formSelector) => {
    $(formSelector).on("change", "input, textarea, select", function (_e) {
      refreshSiblingMessages(this);
      if (isValueMissing($(this))) return; // 未入力の時にエラーメッセージが出るのはユーザーにストレスを与える
      if (!checkFieldValidation($(this))) displayInvalidMessage($(this));
    });
  };

  const indicatePassedValidation = (formSelector) => {
    $(formSelector).on(
      "change keyup",
      "input, textarea, select",
      function (_e) {
        // NOTE: 未入力もしくはバリデーションを通過している時、表示中のエラーメッセージを削除する
        // （なお、生年月日などにおける同じ項目の隣の欄の分は削除せず、再検証して表示する）
        if (isValueMissing($(this)) || checkFieldValidation($(this)))
          refreshSiblingMessages(this);
        putCheckMark($(this));
        changeDesignWhetherToPassedValidation($(this));
      }
    );
  };

  // タグが p_required isTrue の前提になっているため汎用性低
  const putCheckMark = (field) => {
    const itemGroup = field.closest(".jsItemGroup");
    const currentTag = itemGroup.find(
      ".jsRequiredFieldTag, .jsPassedValidationIcon"
    );
    if (currentTag.length == 0) return;
    if (
      Array.from(
        itemGroup[0].querySelectorAll("input, textarea, select")
      ).every((field) => checkFieldValidation(field))
    ) {
      // NOTE: リガチャ文字列(check_circle)がそのまま読み上げられるため装飾扱いにする
      currentTag[0].className = "material-icons jsPassedValidationIcon";
      currentTag[0].textContent = "check_circle";
      currentTag[0].setAttribute("aria-hidden", "true");
    } else {
      currentTag[0].className = "p_required isTrue jsRequiredFieldTag";
      currentTag[0].textContent = "必須";
    }
  };

  const changeDesignWhetherToPassedValidation = (field) => {
    const requiredDesignElement = isCheckBoxOrRadioButton(field)
      ? field.closest(".jsCheckFieldGroup")
      : field;
    if (
      checkFieldValidation(field) ||
      (isBirthday(field) && !isValueMissing(field))
    ) {
      // 誕生日選択のみ特殊処理
      requiredDesignElement.removeClass("required");
    } else {
      requiredDesignElement.addClass("required");
    }
  };

  const displayInvalidMessage = (field) => {
    const element = field instanceof jQuery ? field[0] : field;
    // NOTE: 文言は input の data-error-required / data-error-pattern で指定でき、未指定はブラウザ標準文言を使う
    const errorMessage = validationErrorMessage(element, {
      required: element.dataset.errorRequired,
      pattern: element.dataset.errorPattern,
    });
    if (!errorMessage) return;
    // NOTE: 親を共有する要素（生年月日の年・月・日）で同じ文言が並ばないよう、同一文言は 1 つにまとめる
    const parent = $(element).parent();
    const hasSameMessage = parent
      .children(".jsValidationMessage")
      .toArray()
      .some((message) => message.textContent === errorMessage);
    if (hasSameMessage) return;
    parent.append(
      `<p class='errorMessage jsValidationMessage'>${errorMessage}</p>`
    );
  };

  // NOTE: 親を共有する要素（生年月日の年・月・日）では、1 つの欄の変更で親の赤文言をまとめて消すと、
  //       まだ無効な隣の欄の文言まで消えてしまう。消した後に同じ親の他の欄を再検証して、無効なものの文言は残す
  //       （未入力の欄は「入力中に急かさない」思想のまま出さない）
  const refreshSiblingMessages = (field) => {
    const parent = $(field).parent();
    parent.children(".jsValidationMessage").remove();
    parent
      .children("input, textarea, select")
      .not(field)
      .each((_index, sibling) => {
        if (isValueMissing(sibling) || checkFieldValidation(sibling)) return;
        displayInvalidMessage(sibling);
      });
  };

  const changeAddressFieldDesignWhenInputPostalCode = (formSelector) => {
    const elements = $(`${formSelector} #city, ${formSelector} #prefecture`);
    $(formSelector).on("keyup change", "#jsPostalCode", (_e) => {
      if (isValueMissing(elements)) {
        sleep(0.5, () => {
          // 郵便番号の自動入力後に判定したいためとりあえず0.5秒後に実行されるように
          isValueMissing(elements)
            ? elements.addClass("required")
            : elements.removeClass("required");
        });
      } else {
        elements.removeClass("required");
      }
    });
  };

  const isCheckBoxOrRadioButton = (input) => {
    const element = input instanceof jQuery ? input[0] : input;
    const type = element.getAttribute("type");
    return type == "checkbox" || type == "radio";
  };

  const isBirthday = (select) => select.hasClass("jsBirthdaySelect");

  initializeValidate(formSelector); // デフォルトで入力済みのフィールドに対応
  validateChangedFields(formSelector);
  indicatePassedValidation(formSelector);
  changeAddressFieldDesignWhenInputPostalCode(formSelector); // 郵便番号を入力した時の自動住所入力にデザイン対応
};

// ===========================================================================
// 入力状況（進捗）の表示
const displayProgressInputForm = (
  formSelector,
  remainRequiredFieldCountSelector
) => {
  if ($(remainRequiredFieldCountSelector).length == 0) return;

  const initalizeProgress = (
    formSelector,
    remainRequiredFieldCountSelector
  ) => {
    setRemainFieldCount(formSelector, remainRequiredFieldCountSelector);
  };

  const setProgressValueEachChangeForm = (
    formSelector,
    remainRequiredFieldCountSelector
  ) => {
    $(formSelector).on("change keyup", "input, textarea, select", (_e) => {
      setRemainFieldCount(formSelector, remainRequiredFieldCountSelector);
    });
  };

  const returnAllRequiredItemCount = (formSelector) => {
    const fieldSelector = ".jsRequired:not(#city):not(#prefecture)"; // 都道府県と市区町村を省いている
    return countField(formSelector, fieldSelector);
  };

  const returnPassedItemCount = (formSelector) => {
    const fieldSelector = ".jsRequired:not(#city):not(#prefecture):valid"; // 都道府県と市区町村を省いている
    return countField(formSelector, fieldSelector);
  };

  const countField = (formSelector, fieldSelector) => {
    let fieldCount = 0;
    const fields = $(formSelector).find(fieldSelector);
    const names = collectFieldNames(fields);
    const namesOtherThanBirthday = names.filter(
      (name) => !name.includes("birthday")
    ); // 誕生日選択は特殊
    fieldCount +=
      names.length == namesOtherThanBirthday.length
        ? names.length
        : namesOtherThanBirthday.length + 1;
    return fieldCount;
  };

  const collectFieldNames = (fields) => {
    const names = [];
    fields.each((index, field) => {
      const name = $(field).prop("name");
      if (names.indexOf(name) < 0) names.push($(field).prop("name"));
    });
    return names.filter((name) => name);
  };

  const setRemainFieldCount = (
    formSelector,
    remainRequiredItemCountSelector
  ) => {
    const passedItemCount = returnPassedItemCount(formSelector);
    const allRequiredItemCount = returnAllRequiredItemCount(formSelector);
    $(remainRequiredItemCountSelector).text(
      allRequiredItemCount - passedItemCount
    );
  };

  initalizeProgress(formSelector, remainRequiredFieldCountSelector);
  setProgressValueEachChangeForm(
    formSelector,
    remainRequiredFieldCountSelector
  );
};

/* ----------------------------------------------------------------------------
 * スライド切替形式のフォームにおいてEnterや次へのキー押下時にsubmitや項目遷移されないようにする
------------------------------------------------------------------------------- */
const _blockEnterOnInput = (formSelector) => {
  $(`${formSelector} input`).keydown((e) => {
    if (e.key == "Enter" || e.code == "Enter") {
      e.preventDefault();
    }
  });
};

const _disableItemTransitionByKeyboard = (formSelector) => {
  $(`${formSelector} input, textarea, select`).on("focus", () => {
    $(`${formSelector} input, textarea`)
      .not(".slick-active input, .slick-active textarea")
      .attr("readonly", "readonly");
    $(`${formSelector} select`)
      .not(".slick-active select")
      .attr("disabled", "disabled");
  });

  $(`${formSelector} input, textarea, select`).on("blur", () => {
    $(`${formSelector} input, textarea`)
      .not(".slick-active input,.slick-active textarea")
      .removeAttr("readonly");
    $(`${formSelector} select`)
      .not(".slick-active select")
      .removeAttr("disabled");
  });
};

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

// ===========================================================================
// 送信時バリデーション
// NOTE: realTimeValidation は未入力（required）の赤文言を出さない（入力中に急かさない思想）ため、
//       未入力送信時の赤文言表示はこの関数が担う。既存フォームに影響させないため意図的に独立させている
const validateOnSubmit = (formSelector) => {
  // NOTE: ブラウザ標準の吹き出しの代わりに赤文言を出すため、標準バリデーション UI を抑止する
  $(formSelector).attr("novalidate", true);
  $(formSelector).on("submit", (e) => {
    const form = e.currentTarget;
    // NOTE: 全フィールドが有効なら何もせず通常の送信に渡す
    if (form.checkValidity()) return;
    // NOTE: 無効なフィールドがあるので送信を止める（novalidate によりブラウザは止めてくれない）
    e.preventDefault();
    // NOTE: rails-ujs は defaultPrevented を見ずに disable_with のボタン無効化を行うため、
    //       伝播も止めないと、送信されないのにボタンが「更新中…」のまま固まる
    e.stopPropagation();
    // NOTE: 前回表示した赤文言を消してから、無効なフィールドの下（親要素の末尾）に付け直す。
    //       未入力・形式違反の文言は input の data-error-required / data-error-pattern で指定でき、未指定はブラウザ標準文言を使う
    // NOTE: 削除→追記を要素ごとに行うと、親を共有する後続の有効な要素（例: 居住地の任意の市区町村）が
    //       直前に付いた文言を消してしまうため、先に全文言を消してから無効な要素の分だけ付け直す
    $(form).find(".jsValidationMessage").remove();
    $(form)
      .find("input, textarea, select")
      .each((_index, element) => {
        if (element.validity.valid) return;
        const errorMessage = validationErrorMessage(element, {
          required: element.dataset.errorRequired,
          pattern: element.dataset.errorPattern,
        });
        if (!errorMessage) return;
        // NOTE: 親を共有する要素（生年月日の年・月・日）で同じ文言が並ばないよう、同一文言は 1 つにまとめる
        const parent = $(element).parent();
        const hasSameMessage = parent
          .children(".jsValidationMessage")
          .toArray()
          .some((message) => message.textContent === errorMessage);
        if (!hasSameMessage)
          parent.append(
            `<p class='errorMessage jsValidationMessage'>${errorMessage}</p>`
          );
      });
  });
};

export {
  word_count,
  showAlertBeforeLeaves,
  realTimeValidation,
  validateOnSubmit,
  displayProgressInputForm,
};
